const B_1 = [
    {
        title: '评标委员会管理',
        path: '/bidding/projectflow/pingbiao/pbwyh/list'
    }
]
export default {
    path: 'pbwyh',
    component: () => import(/*webpackChunkName: 'bidding-ping-pbwyh'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/list'),
            meta: {
                title: '评标委员会管理',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/detail'),
            meta: {
                title: '组建评委会管理',
                bread: B_1
            },
        },
        {
            path:"edit",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/edit'),
            meta: {
                title: '组建评委会管理',
                bread: B_1
            },
        },
        {
            path:"yujiazai",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/yu-jia-zai'),
            meta: {
                title: '评标环境预加载-标段列表',
                bread: B_1
            },
        },
        {
            path:"duobdyujiazai",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/all-yu-jia-zai'),
            meta: {
                title: '评标环境预加载-标段列表',
                bread: B_1
            },
        },
        // {
        //     path:"duobdyujiazai",
        //     component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/duo-biao-duan-yu-jia-zai'),
        //     meta: {
        //         title: '评标环境预加载-标段列表',
        //         bread: B_1
        //     },
        // },
        {
            path:"cygl/list",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/list-cheng-yuan'),
            meta: {
                title: '成员管理',
                bread: B_1
            },
        },
        {
            path:"zjpj",
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/form-ping-jia/index'),
            meta: {
                title: '专家评价',
                bread: B_1
            },
        },
        {
            path: 'cygl/form',
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/form-cheng-yuan'),
            meta: {
                title: '编辑成员',
                bread:B_1,
            }
        },
        {
            path: 'pwtbwjyjz',
            component: () => import('@views/bidding/views/project-flow/ping/ping-biao-wei-yuan-hui/sub-pages/yu-jia-zai-wen-jian'),
            meta: {
                title: '评标环境预加载-投标单位列表',
                bread:B_1,
            }
        }
        
    ]
} 